// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__3Z5sE","rotation":"Loader_rotation__2HSce"};